export default __webpack_public_path__ + "static/media/apple-cut.629dfc0c.png";